import { computed, inject, reactive, watch } from 'vue';

import PaymentCreateComponent from '@/components/payment/blocks/create/create.vue';
import PaymentListComponent from '@/components/payment/blocks/list/list.vue';

export default {
  name: 'PaymentBillingDetailsComponent',
  components: { PaymentCreateComponent, PaymentListComponent },
  props: {
    profiles: {
      type: Array,
      required: false,
      default: []
    },
    defaultProfile: {
      type: Number,
      required: false,
      default: null
    },
    selectedProfile: {
      type: Number,
      required: false,
      default: null
    },
    active: {
      type: String,
      required: false,
      default: 'create'
    },
    canCreate: {
      type: Boolean,
      default: false
    },
    showActivationOptions: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  setup(props) {
    const subscriptionProvider = inject('subscriptionProvider');

    const state = reactive({
      active: props.active,
      profiles: computed(() => props.profiles)
    });

    watch(() => state.profiles, (profiles) => {
      if (profiles && profiles.length) {
        toggle('list');
      }
    });

    const toggle = (active) => {
      const creating = 'create' === active;
      subscriptionProvider().setCreatingProfile(creating);
      state.active = active;
    };

    return { state, toggle };
  },
  methods: {
    activate: async function(data) {
      this.$emit('activate', data);
    },
    remove: async function(payment, isDefault, isSelected) {
      this.$emit('remove', payment, isDefault, isSelected);
    },
    update: async function(data) {
      this.$emit('update', data);
    },
    create: async function(data) {
      this.$emit('create', data);
      this.state.active = 'list';
    },
    emitToggle: async function(active) {
      this.$emit('toggle', active);
    }
  }
};
